import { inhouseLogger } from '../inhouseLogger/inhouseLogger';
import type { EventLoggerParams, IEventLogger } from './types';

export class BrowserLogger implements IEventLogger {
  constructor() {}

  log({ channel, eventName, analytics, ablyOnlyLog }: EventLoggerParams) {
    if (__DEV__) {
      console.debug(
        `[BrowserLogger] channel: ${channel}, eventName: ${eventName}, analytics: ${JSON.stringify(
          analytics,
        )}, ablyOnlyLog: ${JSON.stringify(ablyOnlyLog)}`,
      );
    }

    inhouseLogger.log({
      eventName,
      analytics,
      ablyOnlyLog,
    });
  }

  flush(): Promise<void> {
    return inhouseLogger.flush();
  }
}
